const release = {
  commit: "8720e5f5005b3aa16e5f090d4d4ffbbdd3b5f25e",
  version: "202505.72105.40",
};

export default release;
